<div [@inbgOutAnimation] cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListData]="stageTaskList"
  [ngClass]="{'stage-width-1-container': stagecount == 1}" class="container-fluid text-truncate mt-1 pb-4">
  <h6 [matTooltip]="stage.title" class="mb-1 d-inline header-stage cursor-default text-truncate">{{ stage.title }}</h6>
  <h6 class="mb-1 d-inline float-right text-stage cursor-default" *ngIf="stage.stagevisibility == 'vendor_only'">
    <span class="material-icons mb-0 align-bottom cursor-default f-20 lh-17">
      visibility_off
    </span> {{ 'projectstage.vendoronly' | trans }}
  </h6>

  <!----- IS THIS NEEDED?
  <h6 *ngIf="timeregEnabled && stageTimeCounterLabel() as counter"
    class="mb-1 d-inline float-right text-stage cursor-default ml-2" [matTooltip]="stageTimeCounterTooltip()"
    matTooltipPosition="above" matTooltipShowDelay="300">
    {{ counter }}
  </h6>-->

  <div class="row">
    <div class="col pr-0">
      <!-- 
          <p [ngClass]="{'text-truncate': collapsedstage }"
          class="mh-40 text-break text-truncate" 
          style="white-space: break-spaces; max-height: 35px;">{{ stage.description }}</p> -->

      <!-- <p [ngClass]="{'text-truncate': collapsedstage}" 
          class="mh-40 text-break" 
          style="white-space: break-spaces; max-height: 40px;">{{ stage.description }}</p> -->

      <p [ngClass]="{'show': stageinfoToggler}" class="mh-40 text-break show-more"
        style="white-space: break-spaces; overflow: hidden;">{{ stage.description }}</p>

      <!-- BEST VERSION <p [ngClass]="{'line-clamp': collapsedstage, 'mxh-40': collapsedstage}"
          class="mh-40 text-break" 
          style="white-space: break-spaces; overflow: hidden;">{{ stage.description }}</p> -->

      <!-- <p [ngClass]="{'text-truncate': collapsedstage }"
             class="mh-40 text-break text-truncate" 
             style="white-space: break-spaces; max-height: 35px;">{{ stage.description }}</p> -->

      <!-- <p class="text-break collapse" id="stage-options" style="white-space: break-spaces;">{{ stage.description }}</p> -->

    </div>
    <button (click)="stageinfoToggle()" class="border-0 bg-transparent" type="button">
      <span *ngIf="!stageinfoToggler && stageDescriptionLength > 75"
        class="material-icons cursor-pointer btn rounded-circle p-1 icon bg-transparent-soft opacity-reverse">
        expand_more
      </span>
      <span *ngIf="stageinfoToggler"
        class="material-icons cursor-pointer btn rounded-circle p-1 icon bg-transparent-soft opacity-reverse">
        expand_less
      </span>
    </button>
    <div *ngIf="canEditStage()" class="col-auto d-inline-flex pl-0">
      <button [@inbgOutAnimation] *ngIf="canEditStage() && stageoptionToggler"
        matTooltip="{{ 'projectstage.deletestage' | trans }}" matTooltipPosition="left" matTooltipShowDelay="500"
        data-toggle="modal" [attr.data-target]="'#deletestageconfirm' + stage.stageId" class="bg-transparent border-0">
        <span class="material-icons btn portal-icon align-middle rounded-circle p-1">
          delete
        </span>
      </button>
      <button [@inbgOutAnimation] *ngIf="canEditStage() && stageoptionToggler"
        matTooltip="{{ 'projectstage.editstage' | trans }}" matTooltipPosition="left" matTooltipShowDelay="500"
        data-toggle="modal" [attr.data-target]="'#stageeditmodal' + stageindex" class="bg-transparent border-0">
        <span class="material-icons btn portal-icon align-middle rounded-circle p-1">
          create
        </span>
      </button>
      <button (click)="stageoptionToggle()" class="border-0 bg-transparent" type="button">
        <span class="material-icons cursor-pointer btn rounded-circle p-1 icon bg-transparent-soft opacity-reverse">
          more_horiz
        </span>
      </button>
    </div>
  </div>


  <!--- STAGE DESCRIPTION NEEDS TO BE TRUNCATED EVEN WHEN MULTILINE AND SIZES HAVE TO MATCH --->
  <!-- <p class="mh-40 text-break text-truncate mr-3" style="white-space: break-spaces; max-height: 35px;">{{ stage.description }}</p> -->
  <!-- <p class="stage-creator">Creator <app-personname [creatorstage]="'stagedisplay'" [enableChange]="false" [personId]="stage.creator"></app-personname></p> -->
  <div class="row" *ngIf="stage.startdate != null && stage.enddate != null">
    <div class="col">
      <p class="text-truncate">{{ 'projectstage.start' | trans }} {{ stage.startdate | date: 'dd-MM-yyyy'}}</p>
    </div>
    <div class="col">
      <p class="text-truncate float-right">{{ 'projectstage.end' | trans }} {{ stage.enddate | date: 'dd-MM-yyyy'}}</p>
    </div>
  </div>

  <button *ngIf="(projectMembers?.length || 0) > 0" id="createtask" (click)="setNewTask()" data-toggle="modal"
    [attr.data-target]="'#taskmodal' + stageindex" type="button" class="btn w-100 mb-10 pt-0 pb-0 h-40">
    <h6 class="align-middle mb-0 lh-40 w-100 text-left btn-text float-left">{{ 'projectstage.addtask' | trans }}
      <span class="material-icons btn-icon align-middle lh-40 f-18 mr-15 icon-color float-right">
        add
      </span>
    </h6>
  </button>
  <button routerLink="/portal" *ngIf="(projectMembers?.length || 0) == 0" type="button"
    class="btn w-100 mb-10 pt-0 pb-0 h-40">
    <h6 class="w-100 text-left btn-text align-middle lh-40 float-left" matTooltip="assigmemberstip"
      matTooltipPosition="above" matTooltipShowDelay="500">{{ 'projectstage.assigmembers' | trans }}
      <span class="material-icons btn-icon align-middle lh-40 f-18 mr-15 icon-color float-right">
        info
      </span>
    </h6>
  </button>
  <div *ngIf="(stageTaskList?.length || 0) == 0" style="height:70vh;"></div>
  <div *ngFor="let task of stageTaskList; trackBy: trackByTaskId">
    <app-projecttask [listviewsetting]="listview" [commentsList]="commentsList"
      [projectCustomerMembers]="projectCustomerMembers" [projectMembers]="projectMembers"
      [task]="task"></app-projecttask>

  </div>
</div>
<!-- The Task Modal -->
<div class="modal" id="taskmodal{{stageindex}}">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ 'projectstage.createtask' | trans }}</h4>
        <button id="createtaskmodalclose" type="button" class="close" (click)="closeTaskModal()">&times;</button>
      </div>
      <div class="modal-body">
        <app-loadconfirm *ngIf="showSpinner" [text]="'projectstage.loadconfirmcreate' | trans"
          [icon]="'pending'"></app-loadconfirm>
        <form>
          <div class="form-group">
            <label class="font-weight-light f-15 mb-0" for="tasktitle{{stageindex}}">{{ 'projectstage.title' | trans
              }}</label>
            <input required (change)="validate()" type="text" placeholder="{{ 'projectstage.titleplace' | trans }}"
              class="form-control" id="tasktitle{{stageindex}}" aria-describedby="tasktitleHelp" name="title"
              [(ngModel)]="modalTask.title" required>
          </div>
          <div class="form-group">
            <label class="font-weight-light f-15 mb-0" for="taskdescription{{stageindex}}">{{ 'projectstage.description'
              | trans }}</label>
            <quill-editor (change)="validate()" [formats]="formats"
              [placeholder]="'projectstage.descriptionplace' | trans " [modules]="modules" class="w-100 toolontop"
              id="taskdescription{{stageindex}}" name="description" [(ngModel)]="modalTask.description"></quill-editor>
          </div>

          <!---Task responsible--->
          <div class="form-group">
            <label class="font-weight-light f-15 mb-0" for="taskresponsible{{stageindex}}">{{ 'projectstage.responsible'
              | trans }}</label>
            <select required (change)="validate()" class="w-100 h-35 form-control responsible-control"
              id="taskresponsible{{stageindex}}" name="responsible" [(ngModel)]="modalTask.responsible" required>
              <option style="visibility: hidden!important; display: none;" selected [ngValue]="'choose'">
                <p>{{ 'projectstage.choose' | trans }}</p>
              </option>
              <optgroup label="{{ 'projectstage.organization' | trans }}">
                <option *ngFor="let member of projectMembers" [ngValue]="member.personId">
                  <p>{{ member.fullname }}</p>
                </option>
              </optgroup>
              <optgroup label="{{ 'projectstage.customer' | trans }}">
                <option *ngFor="let member of projectCustomerMembers" [ngValue]="member.userId.substr(0,36)" required>
                  <p>{{ member.fullname }}</p>
                </option>
              </optgroup>
            </select>
          </div>
          <div *ngIf="willLoseAccess()" class="form-group rounded p-1 bg-lightgrey">
            <div class="row">
              <div class="col">
                <h6 class="ml-1">{{ 'projectstage.warning' | trans }}</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-8">
                <label class="ml-1 font-weight-light f-15 mb-0" for="taskstartdate{{stageindex}}">
                  {{ 'projectstage.warningdesc' | trans }} </label>
              </div>
              <div class="col-2">
                <input required (change)="validate()" type="checkbox" class="form-control w-30 mt-2 ml-3"
                  id="taskwarning{{stageindex}}" name="stardate" [(ngModel)]="acceptwarning">
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="tasktype">{{ 'projectstage.tasktypeheader' | trans
              }}</label>
            <select class="form-control" id="tasktype" name="tasktype" [(ngModel)]="modalTask.tasktype" required>
              <option selected [ngValue]="'task'">{{ 'projectstage.tasktypetask' | trans }}</option>
              <option [ngValue]="'event'">{{ 'projectstage.tasktypeevent' | trans }}</option>
              <option [ngValue]="'submit'">{{ 'projectstage.tasktypesubmit' | trans }}</option>
              <option [ngValue]="'download'">{{ 'projectstage.tasktypedownload' | trans }}</option>
              <option [ngValue]="'link'">{{ 'projectstage.link' | trans }}</option>
              <option [ngValue]="'form'">{{ 'projectstage.tasktypeform' | trans }}</option>
            </select>
          </div>

          <!---Upload condition field start--->
          <div *ngIf="modalTask.tasktype == 'submit'" class="form-group">
            <ul class="list-group">
              <li *ngFor="let input of modalTask.uploadFields; let i = index; let last = last; trackBy: trackByIndex"
                class="list-group-item">
                <div class="input-group">
                  <input [(ngModel)]="modalTask.uploadFields[i]" name="uploadField{{i}}" type="text"
                    class="form-control" placeholder="{{ 'projectstage.filetitleheader' | trans
              }}">
                  <!---add file--->
                  <div *ngIf="last" (click)="addFileInput()" class="input-group-append">
                    <span class="input-group-text" id="basic-addon2"><span
                        class="material-icons align-middle lh-20 text-center p-0 w-20 h-20 f-20 add-file cursor-pointer ">
                        add
                      </span></span>
                  </div>
                  <!---add file end--->
                  <!---remove file--->
                  <div *ngIf="!last" (click)="removeFileInput(i)" class="input-group-append">
                    <span class="input-group-text" id="basic-addon2"><span
                        class="material-icons align-middle lh-20 text-center p-0 w-20 h-20 f-20 add-file cursor-pointer ">
                        close
                      </span></span>
                  </div>
                  <!---remove file end--->
                </div>
              </li>
            </ul>
          </div>
          <!---Upload condition field end--->

          <!---Form Template Selector (when tasktype='form') start--->
          <div *ngIf="modalTask.tasktype === 'form'" class="form-group">
            <label class="font-weight-light f-15 mb-0" for="formtemplate{{stageindex}}">
              {{ "projecttask.formtemplate" | trans }}
            </label>

            <!-- Loading state -->
            <div *ngIf="loadingForms" class="text-muted">
              <span class="spinner-border spinner-border-sm mr-2"></span>
              {{ "projecttask.loadingforms" | trans }}
            </div>

            <!-- Form selector -->
            <select *ngIf="!loadingForms && hasPublishedForms" class="form-control" id="formtemplate{{stageindex}}"
              name="formTemplateId" [(ngModel)]="modalTask.formTemplateId" (ngModelChange)="onFormSelected()" required>
              <option [ngValue]="null">{{ "projecttask.selectform" | trans }}</option>
              <option *ngFor="let form of publishedForms" [ngValue]="getFormKey(form)">
                {{ form.name }} (v{{ form.version }})
              </option>
            </select>

            <!-- Empty state -->
            <div *ngIf="!loadingForms && !hasPublishedForms" class="alert alert-warning">
              <p class="mb-0">{{ "projecttask.nopublishedforms" | trans }}</p>
              <small>{{ "projecttask.publishformsfirst" | trans }}</small>
            </div>
          </div>
          <!---Form Template Selector end--->

          <!---Link condition fied start---->
          <div *ngIf="modalTask.tasktype == 'link'" class="form-group mb-0">
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="linkurl{{stageindex}}">{{
                  'projectstage.linkurl'
                  |
                  trans }}</label>
                <input (change)="validate()" required type="text" class="form-control " id="linkurl{{stageindex}}"
                  name="warning" [(ngModel)]="modalTask.linkurl">
              </div>
            </div>
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="linktext{{stageindex}}">{{ 'projectstage.linktext' |
                  trans }}</label>
                <input (change)="validate()" required type="text" class="form-control " id="linktext{{stageindex}}"
                  name="duedate" [(ngModel)]="modalTask.linktext">
              </div>
            </div>
          </div>
          <!---Link condition fied end---->

          <!---Download condition fied start---->
          <div *ngIf="modalTask.tasktype == 'download'" class="form-group mb-0">
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="linkurl{{stageindex}}">{{
                  'projectstage.downloadlink'
                  |
                  trans }}</label>
                <input (change)="validate()" required type="url" class="form-control" id="linkurl{{stageindex}}"
                  name="warning" [(ngModel)]="modalTask.linkurl">
              </div>
            </div>
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="linktext{{stageindex}}">{{ 'projectstage.downloadtext' |
                  trans }}</label>
                <input (change)="validate()" required type="text" class="form-control " id="linktext{{stageindex}}"
                  name="duedate" [(ngModel)]="modalTask.linktext">
              </div>
            </div>
          </div>
          <!---Download condition fied end---->
          <!----Event type condition fields---->
          <div *ngIf="modalTask.tasktype == 'event'">
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="taskstartdate{{stageindex}}">{{
                  'projectstage.eventstart'
                  |
                  trans }}</label>
                <input (change)="validate()" required type="datetime-local" class="form-control "
                  id="taskwarning{{stageindex}}" name="warning" [(ngModel)]="modalTask.startdate">
              </div>
            </div>
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="taskduedate{{stageindex}}">{{ 'projectstage.eventend' |
                  trans }}</label>
                <input (change)="validate()" required type="datetime-local" class="form-control "
                  id="taskduedate{{stageindex}}" name="duedate" [(ngModel)]="modalTask.duedate">
              </div>
            </div>
          </div>
          <!----Event type condition fields end---->
          <!----Normal task date and visibility----->
          <ng-container *ngIf="modalTask.tasktype != 'event'">
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="taskstartdate{{stageindex}}">{{ 'projectstage.startdate'
                  |
                  trans }}</label>
                <input (change)="validate()" required type="date" class="form-control " id="taskwarning{{stageindex}}"
                  name="warning" [(ngModel)]="modalTask.startdate">
              </div>
            </div>
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="taskduedate{{stageindex}}">{{ 'projectstage.enddate' |
                  trans }}</label>
                <input (change)="validate()" required type="date" class="form-control " id="taskduedate{{stageindex}}"
                  name="duedate" [(ngModel)]="modalTask.duedate">
              </div>
            </div>
          </ng-container>
          <!----Normal task date and visibility end----->



          <div *ngIf="!isCustomer" class="form-group">
            <label class="font-weight-light f-15 mb-0" for="vendorswitch{{stageindex}}">{{ 'projectstage.visibility' |
              trans }}</label>
            <select (change)="validate()" required class="form-control " id="vendorswitch{{stageindex}}"
              name="taskvisibility" [(ngModel)]="modalTask.taskvisibility">
              <option selected [ngValue]="'shared'">{{ 'projectstage.shared' | trans }}</option>
              <option [ngValue]="'vendor_only'">{{ 'projectstage.vendoronly' | trans }}</option>
            </select>
          </div>

          <div *ngIf="timeregEnabled" class="form-group">
            <label class="font-weight-light f-15 mb-0" for="taskestimate{{stageindex}}">Initial estimate (h)</label>
            <input type="number" min="0" step="0.25" class="form-control" id="taskestimate{{stageindex}}"
              name="taskestimate" [(ngModel)]="newTaskEstimateHours" placeholder="Optional">
          </div>

          <div *ngIf="taskcreatedstate" class="alert alert-success" role="alert">
            {{ 'projectstage.taskcreated' | trans }}
          </div>
          <div *ngIf="errorMessage!=null" class="alert alert-danger ml-0 mr-0">
            <h6 class="error-msg mb-0">{{ errorMessage | trans }}</h6>
          </div>
          <div class="row">
            <div class="col">
              <button id="closeaddtask" type="button" class="btn-close float-left w-100" data-dismiss="modal">
                <h6 class="btn-save-text">{{ 'projectstage.close' | trans }}</h6>
              </button>
            </div>
            <div class="col">
              <button id="addtask" type="button" class="btn-save float-right w-100" (click)="addTask()">
                <h6 class="btn-save-text">{{ 'projectstage.create' | trans }}</h6>
              </button>
            </div>
            <!-- <div class="col">
                    <button [disabled]="!formIsValid" type="button" style="width:100%;" class="btn-save float-right" (click)="addTask()" data-dismiss="modal"><h6 class="btn-save-text">Create and close</h6></button>
                  </div> -->
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="stageeditmodal{{stageindex}}">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ 'projectstage.editstage' | trans }}</h4>
        <button #closeeditmodal type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <form #profileForm="ngForm" (change)="validateEditStage()" (ngSubmit)="editStage()" class="">
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="stagetitle">{{ 'projectstage.stagetitle' | trans }}</label>
            <input type="text" class="form-control" id="stagetitle" aria-describedby="stagetitleplace"
              placeholder="{{ 'projectstage.stagetitleplace' | trans }}" name="title" [(ngModel)]="stage.title"
              required />
            <small *ngIf="errorMessage!=null" id="stagetitlehelp" class="form-text text-muted">{{
              'projectstage.stagetitlehelp' | trans }}</small>
          </div>
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="stagedesc">{{ 'projectstage.stagedescription' | trans
              }}</label>
            <textarea aria-describedby="stagedeschelp" placeholder="{{ 'projectstage.stagedescriptionplace' | trans }}"
              name="description" [(ngModel)]="stage.description" class=" form-control stageinput ta-nr" rows="3"
              required></textarea>
            <small *ngIf="errorMessage!=null" id="stagedeschelp" class="form-text text-muted">{{
              'projectstage.stagedescriptionhelp' | trans }}</small>
          </div>
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="startdate">{{ 'projectstage.startdate' | trans }}</label>
            <input type="date" class=" form-control" id="startdate" name="startdate"
              [ngModel]="stage.startdate| date:'yyyy-MM-dd'"
              (ngModelChange)="stage.startdate = $event; showeditstage = true" required>
          </div>
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="enddate">{{ 'projectstage.enddate' | trans }}</label>
            <input type="date" class=" form-control" id="enddate" name="enddate"
              [ngModel]="stage.enddate| date:'yyyy-MM-dd'"
              (ngModelChange)="stage.enddate = $event; showeditstage = true" required>
          </div>
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="vendorswitch">{{ 'projectstage.visibility' | trans
              }}</label>
            <select class="form-control" id="vendorswitch" name="stagevisibility" [(ngModel)]="stage.stagevisibility"
              (ngModelChange)="showeditstage = true" required>
              <option [ngValue]="'shared'">{{ 'projectstage.shared' | trans }}</option>
              <option [ngValue]="'vendor_only'">{{ 'projectstage.vendoronly' | trans }}</option>
            </select>
          </div>
          <div *ngIf="errorMessage!=null" class="alert alert-danger ml-0 mr-0">
            <h6 class="error-msg mb-0">{{ 'modalvalidation.requiredfieldmissing' | trans }}</h6>
          </div>

          <div *ngIf="showeditstage" class="alert alert-secondary ml-0 mr-0">
            <h6 class="error-msg mb-0">{{ 'modalvalidation.stageeditwarning' | trans }}</h6>
          </div>

          <div class="row">
            <div class="col">
              <button id="closesavestage" type="button" data-dismiss="modal" class="btn-close float-left w-100">
                <h6 class="btn-save-text">{{ 'projectstage.cancel' | trans }}</h6>
              </button>
            </div>
            <div class="col">
              <button id="savestage" (click)="editStage()" type="submit" class="btn-save float-right w-100">
                <h6 class="btn-save-text">{{ 'projectstage.savechanges' | trans }}</h6>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div id="deletestageconfirm{{stage.stageId}}" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'projectstage.confirmdeleteheader' | trans }}</h5>
        <button #deletemodalclose type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="font-weight-light text-center">{{ 'projectstage.confirmdelete' | trans }}</p>
        <p class="mt-2 text-center text-muted">{{ stage.title }}</p>
      </div>
      <div class="modal-footer">
        <div class="col">
          <button id="cancelstagedelete" type="button" class="btn-close" data-dismiss="modal">
            <p class="btn-save-text">{{ 'projectstage.cancel' | trans }}</p>
          </button>
        </div>
        <div class="col">
          <button id="deletestage" (click)="deleteStage()" type="button" class="btn-save">
            <p class="btn-save-text">{{ 'projectstage.deletestage' | trans }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-alertbox *ngIf="showsuccestaskcreate" [@inbgOutAnimation] [alerticon]="'check_circle'" [alerttype]="'success'"
  [alerttext]="'projectstage.successtaskcreate' | trans"></app-alertbox>